import { Col, Input, Row, Typography } from "antd";
import React, { useRef, useState } from "react";

import { useDispatch } from "react-redux";
import { startGetAsistenciasByText } from "../../context/actions/asistenciasActions";
import "./Controles.css";

export const Controles = () => {
  const dispatch = useDispatch();
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const searching = useRef(false);
  const [showValidation, setShowValidation] = useState(false);

  const handleSearch = async () => {
    if (searching.current) return;

    const value = text.trim();
    if (value.length < 4) {
      setShowValidation(true);
      return;
    }

    setShowValidation(false);
    searching.current = true;
    setLoading(true);
    try {
      await dispatch(startGetAsistenciasByText(value));
    } finally {
      searching.current = false;
      setLoading(false);
    }
  };

  const handleChange = ({ target }) => {
    setText(target.value);
    setShowValidation(false);
  };

  return (
    <Row gutter={10} style={{ marginBottom: 10 }}>
      <Col xs={24} sm={12} md={8}>
        <Input.Search
          className="todos-servicios-search"
          value={text}
          placeholder="Buscar..."
          onChange={handleChange}
          enterButton
          onSearch={handleSearch}
          loading={loading}
          disabled={loading}
          status={showValidation ? "error" : undefined}
        />
        {showValidation && (
          <Typography.Text type="danger" role="alert">
            Ingresa al menos 4 caracteres para buscar.
          </Typography.Text>
        )}
      </Col>
    </Row>
  );
};
